<!-- 红包设置组件 -->
<template>
  <div class="red-packet-settings">
    <!-- 红包设置弹窗 -->
    <el-dialog
      title="红包设置"
      :visible.sync="dialogVisible"
      width="800px"
      center
      :show-close="false"
      custom-class="dialogClass"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">红包设置</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="dialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="red-packet-dialog-content">
        <!-- 红包列表 -->
        <div class="red-packet-list" v-if="redPacketList.length > 0">
          <div class="red-packet-card" v-for="(item, index) in redPacketList" :key="index">
            <div class="red-packet-header">
              <img class="red-packet-icon" :src="item.type === 1 ? 'https://ossfastmake.mustke.com/qrCode/tupian/1766556738098.svg' : 'https://ossfastmake.mustke.com/qrCode/tupian/1766556738098.svg'" alt="" />
              <span class="red-packet-title">{{ item.packetType === 1 ? '固定金额红包' : '拼手气红包' }}</span>
            </div>
            <div class="red-packet-divider"></div>
            <div class="red-packet-body">
              <div class="red-packet-item">
                <span class="item-label">已领取金额：</span>
                <span class="item-value">¥{{ item.receivedAmount || 0 }}/{{ item.totalAmount || 0 }}</span>
                <span class="item-link" @click="viewRedPacketDetail(item)">查看领取详情</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">红包发送人昵称：</span>
                <span class="item-value">{{ item.senderName || '某某某' }}</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">中奖概率：</span>
                <span class="item-value">{{ item.probability || 100 }}%</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">抽奖条件：</span>
                <span class="item-value">{{ item.lotteryRuleType==1?'每个账号仅允许抽取一次':'每个账号参与次数与抽奖次数一致' }}</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">创建时间：</span>
                <span class="item-value">{{ item.createTime }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 暂无红包提示 -->
        <div class="no-red-packet" v-else>
          <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg" alt="暂无数据" />
          <p>暂无红包详情，请添加红包</p>
        </div>
        <!-- 继续添加红包按钮 -->
        <div style="text-align: center; margin-top: 20px;">
          <el-button type="primary" @click="openAddRedPacketDialog" icon="el-icon-plus">继续添加红包</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 领取详情弹窗 -->
    <ClaimDetailDialog
      v-model="claimDetailDialogVisible"
      :list="claimDetailList"
      :summary="claimDetailSummary"
    />

    <!-- 支付二维码弹窗 -->
    <el-dialog
      :visible.sync="paymentQrcodeDialogVisible"
      width="420px"
      :show-close="false"
      custom-class="payment-qrcode-dialog"
      @close="closePaymentQrcodeDialog"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">扫码支付</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="handleClosePaymentQrcode"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="payment-qrcode-content">
        <div class="payment-info-item">
          <span class="info-label">应付金额：</span>
          <span class="info-value amount">¥ {{ paymentInfo.amount }}</span>
        </div>
        <div class="payment-info-item">
          <span class="info-label">订单编号：</span>
          <span class="info-value">{{ paymentInfo.orderNo }}</span>
        </div>
        <div class="payment-info-item">
          <span class="info-label">有效期：</span>
          <span class="info-value">{{ paymentInfo.createTime }} 至 无限有效期</span>
        </div>
        <div class="qrcode-section">
          <div class="wechat-pay-logo">
            <img src="@/assets/images/WeChatpay.svg" alt="微信支付" />
          </div>
          <img :src="paymentQrcode" alt="支付二维码" />
          <p class="scan-tip">用微信扫一扫即可付款</p>
          <el-button type="primary" size="small" @click="checkPaymentStatus" :loading="checkingPayment" style="margin-top: 15px;">
            我已支付
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 添加红包弹窗 -->
    <el-dialog
      title="设置红包"
      :visible.sync="addRedPacketDialogVisible"
      width="650px"
      center
      :show-close="false"
      custom-class="dialogClass"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">设置红包</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="addRedPacketDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="add-red-packet-dialog-content">
        <el-form :model="redPacketForm" :rules="redPacketRules" ref="redPacketFormRef" label-width="120px" label-position="left">
          <!-- 第一排：红包抽中概率、红包发送人昵称 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="红包抽中概率" prop="probability">
                <el-input v-model="redPacketForm.probability" type="number" placeholder="请输入概率" style="width: 100%;" @input="limitProbability"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送人昵称" prop="name">
                <el-input v-model="redPacketForm.name" placeholder="请输入昵称" maxlength="15" show-word-limit ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二排：红包类型 -->
          <el-form-item label="红包类型" prop="type">
            <el-radio-group v-model="redPacketForm.type">
              <el-radio :label="1">固定金额红包</el-radio>
              <el-radio :label="2">拼手气红包</el-radio>
            </el-radio-group>
          </el-form-item>


          <!-- 第三排：固定金额红包 - 单个金额、红包个数 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 1">
            <el-col :span="12">
              <el-form-item label="单个金额" prop="singleAmount">
                <el-input v-model="redPacketForm.singleAmount" type="number" placeholder="0.1-200" style="width: 100%;" @input="limitSingleAmount">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="红包个数" prop="redEnvelopesNumber">
                <el-input v-model="redPacketForm.redEnvelopesNumber" type="number" placeholder="1-1000" style="width: 100%;" @input="limitRedEnvelopeNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三排：拼手气红包 - 总金额、红包个数 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 2">
            <el-col :span="12">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input v-model="redPacketForm.totalAmount" type="number" placeholder="请输入总金额" style="width: 100%;" @input="limitTotalAmount">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="红包个数" prop="redEnvelopesNumber">
                <el-input v-model="redPacketForm.redEnvelopesNumber" type="number" placeholder="1-1000" style="width: 100%;" @input="limitRedEnvelopeNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四排：拼手气红包 - 单个红包范围 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 2">
            <el-col :span="12">
              <el-form-item label="最小金额" prop="minimumAmount">
                <el-input v-model="redPacketForm.minimumAmount" type="number" placeholder="最小金额" style="width: 100%;" @input="limitMinimumAmount">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大金额" prop="maximumAmount">
                <el-input v-model="redPacketForm.maximumAmount" type="number" placeholder="最大金额" style="width: 100%;" @input="limitMaximumAmount">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 抽奖条件 -->
          <el-form-item label="抽奖条件" prop="lotteryRuleType">
            <el-radio-group v-model="redPacketForm.lotteryRuleType">
              <el-radio :label="1">每个账号仅允许抽取一次</el-radio>
              <el-radio :label="2">每个账号参与次数与抽奖次数一致</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 温馨提示 -->
          <div class="red-packet-tips">
            <div class="tips-title">温馨提示：</div>
            <div class="tips-content">
              <p>1.若红包金额未被领取完毕，您可在活动结束或手动结束后，申请退回剩余金额。</p>
              <p>2.开通的红包暂不支持开具发票，如有其他疑问，请<span class="tips-link" @click="openCustomerServiceDialog">联系客服</span>。</p>
              <p class="tips-red">3.为确保公平与真实，领取情况、中奖概率等信息将被公开。</p>
              <p>4.平台根据总金额将收取 1% 的手续费，小于 10 元不收取费用。</p>
            </div>
          </div>

          <!-- 总金额显示 -->
          <div class="red-packet-total-price">
            <span>总金额：</span>
            <span class="price-value">¥{{ redPacketCalculatedPrice }}</span>
            <span class="price-tip">(红包总金额 + 手续费)</span>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRedPacketDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRedPacket" :loading="redPacketSubmitting" :disabled="!isRedPacketFormValid">确认支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRedPacketList, createRedPacketOrderPc, getRedPacketDetail, getClaimDetail } from '@/utils/api/activity';
import ClaimDetailDialog from "@/components/ClaimDetailDialog/ClaimDetailDialog.vue";

export default {
  name: 'RedPacketSettings',
  components: { ClaimDetailDialog },
  props: {
    activityId: {
      type: [String, Number],
      required: true,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      redPacketList: [],

      // 领取详情弹窗
      claimDetailDialogVisible: false,
      claimDetailList: [],
      claimDetailSummary: {},

      // 支付二维码弹窗
      paymentQrcodeDialogVisible: false,
      paymentQrcode: '',
      checkingPayment: false,
      paymentInfo: {
        amount: '',
        orderNo: '',
        createTime: ''
      },

      // 添加红包弹窗
      addRedPacketDialogVisible: false,
      redPacketSubmitting: false,
      redPacketForm: {
        probability: 100,
        name: '',
        type: 1, // 1: 固定金额红包，2: 拼手气红包
        singleAmount: '',
        totalAmount: '',
        redEnvelopesNumber: '',
        minimumAmount: '',
        maximumAmount: '',
        lotteryRuleType: 1
      },
      redPacketRules: {
        probability: [
          { required: true, message: '请输入概率', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入发送人昵称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择红包类型', trigger: 'change' }
        ],
        singleAmount: [
          { required: true, message: '请输入单个金额', trigger: 'blur' }
        ],
        totalAmount: [
          { required: true, message: '请输入总金额', trigger: 'blur' }
        ],
        redEnvelopesNumber: [
          { required: true, message: '请输入红包个数', trigger: 'blur' }
        ],
        minimumAmount: [
          { required: true, message: '请输入最小金额', trigger: 'blur' }
        ],
        maximumAmount: [
          { required: true, message: '请输入最大金额', trigger: 'blur' }
        ],
        lotteryRuleType: [
          { required: true, message: '请选择抽奖条件', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    redPacketCalculatedPrice() {
      let amount = 0;
      if (this.redPacketForm.type === 1) {
        amount = (parseFloat(this.redPacketForm.singleAmount) || 0) * (parseInt(this.redPacketForm.redEnvelopesNumber) || 0);
      } else {
        amount = parseFloat(this.redPacketForm.totalAmount) || 0;
      }
      const fee = amount >= 10 ? amount * 0.01 : 0;
      return (amount + fee).toFixed(2);
    },
    isRedPacketFormValid() {
      if (!this.redPacketForm.probability || !this.redPacketForm.name || !this.redPacketForm.redEnvelopesNumber || !this.redPacketForm.lotteryRuleType) {
        return false;
      }
      if (this.redPacketForm.type === 1) {
        if (!this.redPacketForm.singleAmount || this.redPacketForm.singleAmount < 0.1) {
          return false;
        }
      } else if (this.redPacketForm.type === 2) {
        if (!this.redPacketForm.totalAmount || !this.redPacketForm.minimumAmount || !this.redPacketForm.maximumAmount) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    'redPacketForm.probability'(val) {
      if (val < 1) this.redPacketForm.probability = 1;
      if (val > 100) this.redPacketForm.probability = 100;
    },
    'redPacketForm.redEnvelopesNumber'(val) {
      if (val < 1) this.redPacketForm.redEnvelopesNumber = 1;
      if (val > 1000) this.redPacketForm.redEnvelopesNumber = 1000;
    },
    'redPacketForm.singleAmount'(val) {
      if (val < 0.1) this.redPacketForm.singleAmount = 0.1;
      if (val > 200) this.redPacketForm.singleAmount = 200;
    },
    'redPacketForm.totalAmount'(val) {
      if (val < 0.1) this.redPacketForm.totalAmount = 0.1;
    },
    'redPacketForm.minimumAmount'(val) {
      if (val < 0.1) this.redPacketForm.minimumAmount = 0.1;
    },
    'redPacketForm.maximumAmount'(val) {
      if (val < 0.1) this.redPacketForm.maximumAmount = 0.1;
    },
    'redPacketForm.type'() {
      this.$nextTick(() => {
        if (this.$refs.redPacketFormRef) {
          this.$refs.redPacketFormRef.clearValidate();
        }
      });
    }
  },
  methods: {
    // 限制概率输入
    limitProbability() {
      let val = this.redPacketForm.probability;
      if (val && val < 1) val = 1;
      if (val && val > 100) val = 100;
      this.redPacketForm.probability = val;
    },
    // 限制单个金额输入
    limitSingleAmount() {
      let val = this.redPacketForm.singleAmount;
      if (val && val < 0.1) val = 0.1;
      if (val && val > 200) val = 200;
      this.redPacketForm.singleAmount = val;
    },
    // 限制红包个数输入
    limitRedEnvelopeNumber() {
      let val = this.redPacketForm.redEnvelopesNumber;
      if (val && val < 1) val = 1;
      if (val && val > 1000) val = 1000;
      this.redPacketForm.redEnvelopesNumber = val;
    },
    // 限制总金额输入
    limitTotalAmount() {
      let val = this.redPacketForm.totalAmount;
      if (val && val < 0.1) val = 0.1;
      this.redPacketForm.totalAmount = val;
    },
    // 限制最小金额输入
    limitMinimumAmount() {
      let val = this.redPacketForm.minimumAmount;
      if (val && val < 0.1) val = 0.1;
      this.redPacketForm.minimumAmount = val;
    },
    // 限制最大金额输入
    limitMaximumAmount() {
      let val = this.redPacketForm.maximumAmount;
      if (val && val < 0.1) val = 0.1;
      if (val && val > 200) val = 200;
      this.redPacketForm.maximumAmount = val;
    },
    // 打开红包设置弹窗
    async openRedPacketDialog() {
      this.dialogVisible = true;
      await this.loadRedPacketList();
    },
    // 加载红包列表
    async loadRedPacketList() {
      try {
        const { status, data } = await getRedPacketList({
          activityId: this.activityId
        });
        if (status === 1) {
          this.redPacketList = data.list || [];
        } else {
          this.redPacketList = [];
        }
      } catch (error) {
        console.error('加载红包列表失败', error);
        this.redPacketList = [];
      }
    },
    // 打开添加红包弹窗
    openAddRedPacketDialog() {
      this.addRedPacketDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.redPacketFormRef) {
          this.$refs.redPacketFormRef.clearValidate();
        }
      });
    },
    // 提交红包
    async submitRedPacket() {
      try {
        await this.$refs.redPacketFormRef.validate();
      } catch (e) {
        return;
      }

      this.redPacketSubmitting = true;
      try {
        const params = {
          activityId: this.activityId,
          probability: this.redPacketForm.probability,
          senderName: this.redPacketForm.name,
          packetType: this.redPacketForm.type,
          totalAmount: this.redPacketForm.type === 1 ? '' : this.redPacketForm.totalAmount,
          singleAmount: this.redPacketForm.type === 1 ? this.redPacketForm.singleAmount : '',
          packetCount: this.redPacketForm.redEnvelopesNumber,
          minAmount: this.redPacketForm.minimumAmount,
          maxAmount: this.redPacketForm.maximumAmount,
          lotteryRuleType: this.redPacketForm.lotteryRuleType
        };

        const { status, data } = await createRedPacketOrderPc(params);
        if (status === 1 && data) {
          // 显示支付二维码弹窗
          this.paymentQrcode = data.qrCodeBase64;
          this.paymentInfo = {
            amount: data.amount || this.redPacketCalculatedPrice || '88.00',
            orderNo: data.orderNo || '',
            createTime: this.formatDate(new Date()),
          };
          this.paymentQrcodeDialogVisible = true;
          // 关闭添加红包弹窗
          this.addRedPacketDialogVisible = false;
          // 重置表单
          this.resetRedPacketForm();
          // 开始轮询检查支付状态
          this.checkPaymentStatus(data.orderNo);
        } else {
          this.$message.error('红包创建失败');
        }
      } catch (error) {
        console.error('红包创建失败', error);
        this.$message.error('红包创建失败');
      } finally {
        this.redPacketSubmitting = false;
      }
    },
    // 重置表单
    resetRedPacketForm() {
      this.redPacketForm = {
        probability: 100,
        name: '',
        type: 1,
        singleAmount: '',
        totalAmount: '',
        redEnvelopesNumber: '',
        minimumAmount: '',
        maximumAmount: '',
        lotteryRuleType: 1
      };
    },
    // 关闭支付二维码弹窗
    closePaymentQrcodeDialog() {
      this.paymentQrcodeDialogVisible = false;
    },
    // 手动关闭支付二维码
    handleClosePaymentQrcode() {
      this.paymentQrcodeDialogVisible = false;
    },
    // 检查支付状态
    async checkPaymentStatus(orderNo) {
      this.checkingPayment = true;
      const pollOrderNo = orderNo || this.paymentInfo.orderNo;
      try {
        // 轮询检查支付状态
        const checkPayment = async () => {
          try {
            const { status, data } = await getRedPacketDetail({
              orderNo: pollOrderNo
            });
            if (status === 1 && data && data.paid) {
              this.paymentQrcodeDialogVisible = false;
              this.$message.success('支付成功');
              await this.loadRedPacketList();
              return;
            }
          } catch (e) {
            console.error('检查支付状态失败', e);
          }
          // 继续轮询
          setTimeout(checkPayment, 2000);
        };
        checkPayment();
      } catch (error) {
        console.error('检查支付状态失败', error);
      } finally {
        this.checkingPayment = false;
      }
    },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 查看红包详情
    async viewRedPacketDetail(item) {
      try {
        // 尝试使用 packetId 或 id
        const packetId = item.packetId || item.id;
        if (!packetId) {
          this.$message.warning('该红包暂无详情');
          return;
        }
        const { status, data } = await getClaimDetail({
          packetId: packetId
        });
        if (status === 1 && data) {
          this.claimDetailList = data.claimList || [];
          this.claimDetailSummary = {
            claimedCount: data.claimedCount || 0,
            totalCount: data.totalCount || 0,
            claimedAmount: data.claimedAmount || 0,
            totalAmount: data.totalAmount || 0,
          };
          this.claimDetailDialogVisible = true;
        } else {
          this.$message.warning('获取红包详情失败');
        }
      } catch (error) {
        console.error('获取红包详情失败', error);
        this.$message.error('获取红包详情失败');
      }
    },
    // 打开客服对话框
    openCustomerServiceDialog() {
      // 打开客服对话框 - 尝试使用父页面的方法
      let parent = this.$parent;
      while (parent) {
        if (parent.customerServiceDialogVisible !== undefined) {
          parent.customerServiceDialogVisible = true;
          return;
        }
        parent = parent.$parent;
      }
      // 如果找不到，显示提示
      this.$message.info('当前页面不支持客服功能');
    }
  }
};
</script>

<style scoped>
.red-packet-settings {
  display: inline-block;
}

/* 红包设置弹窗样式 */
.red-packet-dialog-content {
  padding: 0;
  max-height: 500px;
  overflow-y: auto;
}

.red-packet-list {
  margin-bottom: 20px;
}

.red-packet-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.red-packet-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.red-packet-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.red-packet-title {
  font-size: 16px;
  font-weight: 600;
  color: #191919;
}

.red-packet-divider {
  height: 1px;
  background: #f0f0f0;
  margin-bottom: 12px;
}

.red-packet-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.red-packet-item {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.6;
}

.red-packet-item .item-label {
  color: #909399;
  min-width: 140px;
  flex-shrink: 0;
}

.red-packet-item .item-value {
  color: #333;
  flex: 1;
}

.red-packet-item .item-link {
  color: #1877ff;
  cursor: pointer;
  margin-left: 10px;
}

.red-packet-item .item-link:hover {
  text-decoration: underline;
}

.no-red-packet {
  text-align: center;
  padding: 40px 0;
  color: #999;
}

.no-red-packet img {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}

.no-red-packet p {
  font-size: 14px;
  color: #666;
}

/* 对话框标题样式 */
.dialog-title {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
}

.dialog-title-text {
  font-weight: bold;
  display: inline-block;
  font-size: 20px;
  color: black;
  max-width: calc(100% - 60px);
  word-break: break-all;
  vertical-align: middle;
}

.custom-close {
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* 支付二维码弹窗样式 */
.payment-qrcode-dialog {
  text-align: left;
}

.payment-qrcode-dialog .dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-qrcode-dialog .dialog-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #191919;
}

.payment-qrcode-dialog .custom-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.payment-qrcode-content {
  padding: 10px 0;
}

.payment-qrcode-content .payment-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;
}

.payment-qrcode-content .payment-info-item .info-label {
  color: #333;
  min-width: 70px;
  flex-shrink: 0;
}

.payment-qrcode-content .payment-info-item .info-value {
  color: #333;
  flex: 1;
}

.payment-qrcode-content .payment-info-item .info-value.amount {
  color: #ff983a;
  font-weight: 600;
  font-size: 18px;
}

.payment-qrcode-content .qrcode-section {
  margin-top: 20px;
  text-align: center;
}

.payment-qrcode-content .qrcode-section .wechat-pay-logo {
  margin-bottom: 10px;
}

.payment-qrcode-content .qrcode-section .wechat-pay-logo img {
  width: 120px;
  height: auto;
}

.payment-qrcode-content .qrcode-section img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.payment-qrcode-content .qrcode-section .scan-tip {
  font-size: 12px;
  color: #999;
  margin: 8px 0 0;
}

/* 添加红包弹窗样式 */
.add-red-packet-dialog-content {
  padding: 0;
}

.add-red-packet-dialog-content :deep(.el-form-item__content) {
  text-align: left;
}

.add-red-packet-dialog-content :deep(.el-radio-group) {
  text-align: left;
}

.add-red-packet-dialog-content :deep(.el-form-item.is-required .el-form-item__label::before) {
  display: none;
}

.red-packet-tips {
  margin-top: 20px;
}

.red-packet-tips .tips-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.red-packet-tips .tips-content p {
  font-size: 13px;
  color: #666;
  line-height: 22px;
  margin: 0;
}

.red-packet-tips .tips-content .tips-red {
  color: #f56c6c;
}

.red-packet-tips .tips-content .tips-link {
  color: #1877ff;
  cursor: pointer;
}

.red-packet-tips .tips-content .tips-link:hover {
  text-decoration: underline;
}

.red-packet-total-price {
  margin-top: 20px;
  text-align: right;
}

.red-packet-total-price .price-value {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
}

.red-packet-total-price .price-tip {
  font-size: 12px;
  color: #999;
  margin-left: 5px;
}
</style>
